import { render } from "./ContentBox.vue?vue&type=template&id=64deb78a&scoped=true"
import script from "./ContentBox.vue?vue&type=script&lang=js"
export * from "./ContentBox.vue?vue&type=script&lang=js"

import "./ContentBox.vue?vue&type=style&index=0&id=64deb78a&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64deb78a"]])

export default __exports__